import type { DeepPartial } from '@luna/utils-ts';

import type { Payments } from './Payments';

export const HR: DeepPartial<Payments> = {
    handleLocalErrors: {
        enabled: true,
    },
    receiverEditInModal: {
        enabled: true,
    },
    verificationOfPayee: {
        enabled: true,
    },
};
